'use client';

import React from 'react';
import Link from 'next/link';
import { ChevronLeft } from 'lucide-react';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen pb-12" style={{ background: 'var(--background)', color: 'var(--foreground)' }}>
      {/* Header */}
      <div
        className="sticky top-0 z-10 flex items-center gap-3 px-4"
        style={{
          background: 'rgba(27,29,35,0.96)',
          borderBottom: '1px solid var(--border)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          paddingTop: 'calc(env(safe-area-inset-top, 44px) + 12px)',
          paddingBottom: '12px',
        }}
      >
        <Link
          href="/profile"
          className="p-2 rounded-full transition-colors active:scale-95"
          style={{ background: 'var(--muted)', color: 'var(--muted-foreground)' }}
          aria-label="Zurück"
        >
          <ChevronLeft size={18} />
        </Link>
        <h1 className="text-base font-semibold" style={{ color: 'var(--card-foreground)' }}>Impressum</h1>
      </div>

      {/* Content */}
      <div className="max-w-mobile mx-auto px-4 pt-6 space-y-8">

        <section>
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--muted-foreground)' }}>
            Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)
          </p>
          <div
            className="rounded-app p-4 space-y-1"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-sm font-semibold" style={{ color: 'var(--card-foreground)' }}>WINEWOOD Adventure</p>
            <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>Sagterländer Str. 6</p>
            <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>28259 Bremen</p>
            <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>Deutschland</p>
            <a
              href="mailto:hello@winewood-adventure.com"
              className="text-sm block mt-2 transition-colors"
              style={{ color: 'var(--primary)' }}
            >
              hello@winewood-adventure.com
            </a>
          </div>
        </section>

        <section>
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--muted-foreground)' }}>
            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
          </p>
          <div
            className="rounded-app p-4 space-y-1"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-sm font-semibold" style={{ color: 'var(--card-foreground)' }}>Jannik Weinholtz</p>
            <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>Sagterländer Str. 6</p>
            <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>28259 Bremen</p>
            <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>Deutschland</p>
          </div>
        </section>

        <section>
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--muted-foreground)' }}>
            Art des Angebots
          </p>
          <div
            className="rounded-app p-4"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              WINEWOOD Adventure ist eine Plattform zur Vermittlung und Darstellung von Freizeitangeboten sowie GPS-basierten Abenteuern und Erlebnissen. Zusätzlich organisiert und vermittelt WINEWOOD Adventure eigene Freizeitangebote und Abenteuer.
            </p>
          </div>
        </section>

        <section>
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--muted-foreground)' }}>
            Umsatzsteuer
          </p>
          <div
            className="rounded-app p-4"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Gemäß § 19 UStG (Kleinunternehmerregelung) wird keine Umsatzsteuer ausgewiesen.
            </p>
          </div>
        </section>

        <section>
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--muted-foreground)' }}>
            Streitschlichtung
          </p>
          <div
            className="rounded-app p-4 space-y-3"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            </p>
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm break-all transition-colors"
              style={{ color: 'var(--primary)' }}
            >
              https://ec.europa.eu/consumers/odr
            </a>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Ich bin weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>
        </section>

      </div>
    </div>
  );
}
